<template>
  <div class="main">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">店员信息</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>

    <div>
      <img src="../../assets/img/头像page.jpg" class="back-img" />
    </div>

    <div class="info-black">
      
      <div class="ub info-block">
        <div class="photo-block ub ub-ver ub-pc">
          <div class="infoma ub">
            <div class="photo-black">
              <img :src="info.photo" class="photo" />
              <span class="photo-tag ub ub-pc ub-ac">{{ info.play_level }}</span>
            </div>
          </div>

          <div>
            <div class="voice ub ub-pc">
              <img src="../../assets/img/声音.png" class="voice-img" />
              <span>播放</span>
            </div>
          </div>
        </div>

        <div class="ub ub-ver ub-f1">
          <div class="ub">
            <div class="ub ub-pc">
              <span class="nick2">{{ info.nick }}</span>
            </div>
            <div class="ub ub-f1 ub-ae">
              <div
                class="tip ub ub-pc"
                v-for="(i, index) in info.service_type"
                :key="index"
              >
                <div class="d1"></div>
                <span class="sp2">{{ i }}</span>
              </div>
            </div>
          </div>

          <div class="info-txt">
            <span>{{ info.sex }}</span>
            <span>{{ info.age_range }}</span>
            <span>{{ info.loc_province }},{{info.loc_city}}</span>
            <span>{{ info.price }}</span>
          </div>

          <div>
            <span class="tag" v-for="(t, index) in info.tags" :key="index">{{
              t
            }}</span>
          </div>

          <div class="sign-name">
            <span>签名:&nbsp;</span>
            <span>{{ info.sign_self }}</span>
          </div>
        </div>
      </div>

      <div class="comment" v-if="comment.length>0">
        <div class="ub ub-pc ub-ac2" @click="goto_comment()">
          <span>评论<label>({{comment.length}})</label></span>
          <div class="ub ub-pc">
            <span>查看全部</span>
            <img src="../../assets/img/箭头 -右.png" class="arrow-img" />
          </div>
        </div>

        <div class="ub ub-ac ub-ver">
          <div class="comment-info ub ub-pc">
            <img :src="comment[0].photo" class="comment-img" />
            <span>{{comment[0].nick}}</span>
          </div>
          <span>{{comment[0].com_dtl}}</span>
        </div>
      </div>

      <div class="form">
        <table class="tbl">
          <tr>
            <td
              colspan="2"
              style="font-size: 0.9em; font-weight: bold; font-size: 0.95em;text-align: center;"
            >
              <label>服务项目</label>
            </td>
            <td style="font-size: 0.9em; font-weight: bold; font-size: 0.95em;text-align: center;">
              <label>价格</label>
            </td>
          </tr>
          <tr>
            <td
              rowspan="4"
              style="font-size: 0.9em; font-weight: bold; font-size: 0.95em"
            >
              <span>文字语音条</span>
            </td>
            <td><span>1小时</span></td>
            <td>
              <span v-if="info.mny_config.item1.hour>0">￥{{info.mny_config.item1.hour}}</span>
              <span v-if="info.mny_config.item1.hour==0" style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1天</span></td>
            <td>
              <span v-if="info.mny_config.item1.day>0">￥{{info.mny_config.item1.day}}</span>
              <span v-if="info.mny_config.item1.day==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1周</span></td>
            <td>
              <span v-if="info.mny_config.item1.week>0">￥{{info.mny_config.item1.week}}</span>
              <span v-if="info.mny_config.item1.week==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1个月</span></td>
            <td>
              <span v-if="info.mny_config.item1.month>0">￥{{info.mny_config.item1.month}}</span>
              <span v-if="info.mny_config.item1.month==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td
              rowspan="4"
              style="font-size: 0.9em; font-weight: bold; font-size: 0.95em"
            >
              <span>语音通话</span>
            </td>
            <td><span>1小时</span></td>
            <td>
              <span v-if="info.mny_config.item2.hour>0">￥{{info.mny_config.item2.hour}}</span>
              <span v-if="info.mny_config.item2.hour==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1天</span></td>
            <td>
              <span v-if="info.mny_config.item2.day>0">￥{{info.mny_config.item2.day}}</span>
              <span v-if="info.mny_config.item2.day==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1周</span></td>
            <td>
              <span v-if="info.mny_config.item2.week>0">￥{{info.mny_config.item2.week}}</span>
              <span v-if="info.mny_config.item2.week==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1个月</span></td>
            <td>
              <span v-if="info.mny_config.item2.month>0">￥{{info.mny_config.item2.month}}</span>
              <span v-if="info.mny_config.item2.month==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td
              rowspan="4"
              style="font-size: 0.9em; font-weight: bold; font-size: 0.95em"
            >
              <span>游戏陪玩</span>
            </td>
            <td><span>1小时</span></td>
            <td>
              <span v-if="info.mny_config.item3.hour>0">￥{{info.mny_config.item3.hour}}</span>
              <span v-if="info.mny_config.item3.hour==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1天</span></td>
            <td>
              <span v-if="info.mny_config.item3.day>0">￥{{info.mny_config.item3.day}}</span>
              <span v-if="info.mny_config.item3.day==0"  style="color:orange;">暂无此服务</span>
              </td>
          </tr>
          <tr>
            <td><span>1周</span></td>
            <td>
              <span v-if="info.mny_config.item3.week>0">￥{{info.mny_config.item3.week}}</span>
              <span v-if="info.mny_config.item3.week==0"  style="color:orange;">暂无此服务</span>
            </td>
          </tr>
          <tr>
            <td><span>1个月</span></td>
            <td>
              <span v-if="info.mny_config.item3.month>0">￥{{info.mny_config.item3.month}}</span>
              <span v-if="info.mny_config.item3.month==0" style="color:orange;">暂无此服务</span>
             </td>
          </tr>
        </table>
      </div>
    </div>

    

    <div class="place-order ub ub-ac">
      <div class="ub ub-ac ub-pc submit-btn" @click="goto_play_order()">
        <span>立即下单</span>
      </div>
    </div>
<div style="height: 5em"></div>

    <dlg ref="play_order" @formplayorder="formplayorderFun"></dlg>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../../components/Play_Order.vue";
export default {
  components: {
    dlg: Form,
  },
  data() {
    return {
      uid_to: "",
      info: {
        id: "123345346575678",
        photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
        honor: "镇店",
        nick: "鸣人",
        sex: "女生",
        age_range: "22岁",
        loc_province:"山西省",
        loc_city:"阳泉市",
        loc_area:"平定县",
        price: "40元起",
        service_type: ["在线", "语音", "陪玩"],
        tags: ["甜甜咸咸", "乖巧", "爱狗狗", "哄睡", "小话唠"],
        sign_self: "我是小熊保安,爱吃小熊饼干",
        vol: "",
        play_level:"",
        mny_config:{}
      },
      comment:[{"photo":"photo_boy/1167.jpg","nick":"梦过后","com_dtl":"服务不太行，后悔了。。。"},
      {"photo":"photo_boy/1167.jpg","nick":"梦过后2","com_dtl":"服务不太行，后悔了。。。2"},
      {"photo":"photo_boy/1167.jpg","nick":"梦过后3","com_dtl":"服务不太行，后悔了。。3"}]
    };
  },
  mounted() {
    this.uid_to = this.$route.params.uid_to;
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      //this.$router.go(-1); //返回上一层
      this.$router.push({ name: "play_list"});
    },
    goto_comment() {
      this.$router.push({ name: "play_comment", "params": { "uid_to":this.uid_to} });
    },
    goto_play_order() {
      // this.$router.push({ name: "play_order" });
      var h = "";
      
      this.$refs.play_order.show(h, {
        type: "confirm",
        confirmText: "立即开通",
        titleText: "订单",
        data: this.info,
      });
    


    },
    formplayorderFun(type, data) {
      if (type == "clickConfirm") {
      }
    },
    init_page() {
      var self = this;
      this.$loading("加载...");
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_Play_Data_One/?uid=" + this.uid_to,
        success: function (data) {
          self.$loading.close();
          data.tags=data.tags.split(',');
          data.mny_config=JSON.parse(data.mny_config);
          self.info=data;
        },
      });
      this.getcommentdata();

    },

    getcommentdata(){
      var self = this;
      self.get({
        url: "/App/Get_Comment_Data/?uid=" + this.uid_to,
        success: function (data) {
         console.log(JSON.stringify(data));

         for (var i = 0; i < data.length; i++) {
            data[i].photo = self.$store.state.url + "/photo/" + data[i].photo;
          }
          self.comment = data;
        },
      });
    }




  },
};
</script>

<style scoped>
.main {
  position: absolute;
  background-color: #f5f5f5;
  width: 100%;
  bottom: 0;
  top: 0;
}
.back-img {
  width: 100%;
}
.info-black {
  padding: 0.5em;
}
.info-block {
  padding: 0.5em;
  background-color: #fff;
  border-radius: 0.5em;
  margin-bottom: 0.8em;
}
.infoma {
  margin: 0.5em 0;
}
.photo-black {
  width: 5.2em;
  height: 5.2em;
  position: relative;
}
.photo-block {
  padding-right: 0.8em;
}
.photo-tag {
  position: absolute;
  background-color: #f3b4cf;
  font-size: 0.8em;
  border-radius: 1em;
  color: #fff;
  padding: 0.1em 0.2em;
  width: 3em;
  bottom: 0em;
  right: 0.3em;
}
.photo {
  width: 5.2em;
  height: 5.2em;
  border-radius: 50%;
  margin-right: 0.5em;
}
.nick2 {
  font-weight: bold;
  font-size: 0.95em;
  margin-left: 0.4em;
}
.tip {
  margin-left: 0.5em;
}
.tip .d1 {
  width: 0.5em;
  height: 0.5em;
  background-color: #5ea3ef;
  border-radius: 50%;
  margin-right: 0.2em;
}
.tip .sp2 {
  font-size: 0.85em;
}
.info-txt {
  font-size: 0.9em;
  padding: 0.3em;
  color: #5ea3ef;
}
.info-txt span {
  margin-right: 0.5em;
}
.tag {
  display: inline-block;
  padding: 0.1em 0.5em;
  border: 1px solid #5ea3ef;
  border-radius: 1em;
  font-size: 0.8em;
  color: #5ea3ef;
  margin: 0.2em 0.2em;
}
.sex-img {
  width: 1.2em;
}
.voice {
  background-color: #5ea3ef;
  font-size: 0.8em;
  width: 6em;
  color: #fff;
  padding: 0.5em 0.5em;
  border-radius: 2em;
}
.voice-img {
  width: 1.5em;
  height: 1.5em;
  margin-left: 0.5em;
}
.sign-name {
  padding: 0.3em;
  font-size: 0.95em;
}
.comment {
  padding: 0.5em;
  background-color: #fff;
  border-radius: 0.5em;
  font-size: 0.9em;
  color: #333;
  margin-bottom: 0.8em;
}
.arrow-img {
  width: 1.3em;
}
.comment-info {
  margin: 1.4em 0 0.3em 0;
}
.comment-img {
  width: 2em;
  height: 2em;
  border-radius: 50%;
  margin-right: 0.5em;
}
.place-order {
  padding: 1.2em;
  background-color: #fff;
  position: fixed;
  bottom: 0em;
  left: 0;
  right: 0;
}
.submit-btn {
  width: 100%;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 1.25em;
  background-color: #fc568c;
  color: #fff;
}

.tbl td {
  border: 1px solid #f1f1f1;
  text-align: left;
  padding: 0.4em 0;
  color: #333;

}
.tbl td span{
  padding: 0 0 0 2em;
}
.tbl tr {
  border: none;
}
.tbl {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  font-size: 0.9em;
  border: none;
  border-spacing: 0;
  border-radius: .8em;
}
</style>